import { CONTENT } from "@bitComponents/unifiedComponents/Stopper";
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from "@bitComponents/unifiedComponents/Button";
import { CALL_GENERIC_1004, CALL_GENERIC_900, DEBT_PAYMENT, PHONE_900, URLS } from "../errorTextsConstants";


export const getErrorToPrint = ( goToC2C ) => {
  return {
    INCORRECT_PARAMS: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        msg: ["Uppss... algo ha ido mal.", "Por favor, inténtalo más tarde."],
        errorName: "Parámetros recibidos en el flujo de compra incorrectos.",
      },
    },
    CLIENT_RISK_DOC_NEEDED: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        buttons: [
          {
            label: "Aceptar",
            link: URLS.HOME,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        title: "Algo ha ido mal",
        msg: [
          "Tras comprobar tus datos no es posible seguir con el pedido en curso.",
          "Hemos enviado un correo a tu mail de contacto con las instrucciones para solucionarlo.",
          "Si no recibes el mail actualiza tu mail de contacto y vuelve a intentarlo",
        ],
        errorName: "riesgo documentacion",
      },
    },
    CLIENT_WITH_DEBT: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        buttons: [
          DEBT_PAYMENT,
        ],
        title: "Hemos detectado un problema con alguna de tus facturas",
        msg: ["Puedes revisar su estado en el siguiente enlace y proceder al pago si es necesario.", "Después podrás continuar con tu pedido. Sentimos las molestias."],
        errorName: "cliente deuda",
      },
    },
    CLIENT_RISK_VALIDATION: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        buttons: [
          {
            label: "Llama gratis al 900104430",
            link: 'tel:900104430',
            forceExternal: true,     
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
            color: BUTTON_COLOR.BLUE,
          },
        ],
        title: "Error en la validación",
        msg: [
          "Tras validar tus datos no es posible seguir con el pedido en curso.",
          "Para solucionarlo es necesario que llames gratis al 900181004.",
        ],
        errorName: "riesgo documentacion",
      },
    },
    PRODUCT_REGISTERED: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: "Producto ya contratado",
        msg: ["Actualmente ya tienes contratado este producto"],
        errorName: "producto ya en parque",
      },
    },
    INCOMPATIBLE_PRODUCT: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: "Producto incompatible",
        msg: [
          "El producto seleccionado es incompatible con tus productos actuales.",
        ],
        errorName: "producto incompatible",
      },
    },
    CUSTOMER_ORDER_IN_PROGRESS: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        buttons: [
          {
            label: "Ir a seguimiento de pedidos",
            link: URLS.URL_TRACKING_CO,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
            color: BUTTON_COLOR.BLUE,
          },
        ],
        title: "Aviso",
        msg: [
          "Actualmente tienes otro pedido en curso.",
          "No es posible realizar un nuevo pedido hasta que se complete el anterior",
        ],
        errorName: "pedido en curso",
      },
    },
    WITHOUT_COVERAGE: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        msg: [
          "Lamentablemente no dispones de cobertura fibra en la dirección de instalación.",
          `Para continuar con tu compra puedes llamar gratis al ${PHONE_900} y un asesor comercial te ayudará a gestionar el cambio solicitado.`,
        ],
        buttons: [CALL_GENERIC_900],
        errorName: "sin cobertura",
      },
    },
    INCORRECT_PRODUCT_OFFERING_STATE: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        msg: [`Para continuar con tu compra llámanos gratis al ${PHONE_900}.`],
        buttons: [CALL_GENERIC_900],
        errorName: "oferta en estado incorrecto",
      },
    },
    GO_TO_900: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        buttons: [CALL_GENERIC_900],
        msg: [`Para continuar con tu compra llámanos gratis al ${PHONE_900}.`],
        errorName: "tapon",
        noRedirectNovum: true,
      },
    },
    FUSION_MANDATORY: {
      errorType: CONTENT.ERROR_ALERT,
      errorInfo: {
        title: "Producto incompatible",
        msg: [
          "Tras revisar tus datos no cumples las condiciones para contratar este producto.",
          "Es necesario tener contratado Fusión/miMovistar previamente.",
        ],
        buttons: [
          {
            link: URLS.PACK_CONFIG,
            label: "Ver productos miMovistar",
            color: BUTTON_COLOR.BLUE,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: "fusión requerido",
      },
    },
    MAX_R2R_REACHED: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: "Actualmente no puedes añadir más dispositivos a tu pack",
        msg: ["Descubre la oferta disponible para ti"],
        buttons: [
          {
            color: BUTTON_COLOR.BLUE,
            link: URLS.VTL_CATALOG,
            label: "Ir a móviles y electrónica",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: "max r2r error",
      },
    },
    LOW_SENIORITY_R2R: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: "Lo sentimos, no podemos continuar con tu pedido online",
        msg: ["Por seguridad en la recogida y firma del contrato del dispositivo debes ir a una tienda online"],
        buttons: [
          {
            color: BUTTON_COLOR.BLUE,
            link: URLS.HOME,
            label: "Volver a movistar.es",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
          {
            color: BUTTON_COLOR.WHITE_BLUE,
            link: URLS.SEARCH_SHOP,
            label: "Buscar tienda Movistar",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: "max r2r error",
      },
    },
    RISK_VALIDATION_UNAVAILABLE: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: "Lo sentimos, no podemos continuar con tu pedido",
        msg: ["Inténtalo de nuevo pasados unos minutos."],
        buttons: [
          {
            color: BUTTON_COLOR.BLUE,
            link: URLS.HOME,
            label: "Volver a movistar.es",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: "risk validation unavailable",
      },
    },
    GO_LOGIN: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: 'Ya eres cliente de Movistar',
        msg: ['Por seguridad debes iniciar sesión para seguir con tu compra'],
        buttons: [
          {
            label: 'Iniciar sesión',
            color: BUTTON_COLOR.BLUE,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: 'login requerido',
      },
    },
    BUY_ALREADY_DONE: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: 'Estás solicitando la baja de un producto que ya no tienes contratado.',
        msg: ['Si has solicitado el cambio hace pocos minutos es posible que la información no esté todavía actualizada en el configurador de TV.','Para conocer el estado real de tu pedido accede al seguimiento de pedidos de tu área cliente.'],
        buttons: [
          {
            color: BUTTON_COLOR.BLUE,
            link: URLS.URL_TRACKING_CO,
            label: "Ver mis pedidos",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: 'movimiento seleccionado incorrecto',
      },
    },
    SPEED_UNAVAILABLE: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: 'Estás solicitando un cambio de velocidad que no tienes disponible',
        msg: ['Si has solicitado el cambio hace pocos minutos es posible que la información no esté todavía actualizada.','Para conocer el estado real de tu pedido accede al seguimiento de pedidos de tu área cliente.'],
        buttons: [
          {
            color: BUTTON_COLOR.BLUE,
            link: URLS.URL_TRACKING_CO,
            label: "Ver mis pedidos",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
        ],
        errorName: 'cambio de velocidad no disponible',
      },
    },
    CLIENT_ADVICE: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: 'Es necesario que te pongas en contacto con nosotros',
        msg: [
          'Lamentablemente tras revisar tus datos no podemos realizar la contratación que solicitas de forma automática.',
          'Puedes lamar gratis al 900181004 y realizaremos la gestión correspondiente.',
          'Sentimos las molestias ocasionadas'
        ],
        errorName: 'aviso ex cliente',
      },
    },
    PROMOTION_NOT_APPLIED: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        title: "Lo sentimos, no podemos continuar con tu pedido online.",
        msg: [
          "Para continuar con tu pedido es necesario que te pongas en contacto con el 1004.",
        ],
        buttons: [CALL_GENERIC_1004],
        errorName: "promocion no aplicada",
      },
    },
    DEFAULT_ERROR: {
      errorType: CONTENT.INFO_ALERT,
      errorInfo: {
        msg: ["Uppss... algo ha ido mal.", "Por favor, inténtalo más tarde."],
        errorName: "error generico",
      },
    },
  }
};
